export default function Toggle({ value, onChange, label, icon: Icon }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 7,
        padding: "7px 12px",
        borderRadius: 8,
        border: `1px solid ${value ? "var(--accent)" : "var(--line-2)"}`,
        background: value ? "var(--accent-soft)" : "transparent",
        color: value ? "var(--accent)" : "var(--ink-2)",
        fontSize: 12.5,
        fontWeight: 500,
        cursor: "pointer",
        fontFamily: "var(--ui)",
        transition: "all 0.15s",
      }}
    >
      {Icon && <Icon size={13} stroke="currentColor" />}
      {label}
    </button>
  );
}
